import { useTranslation } from 'react-i18next';
import { buildCrossDomainLink } from '../../../utils/buildCrossDomainLink';

const CrossDomainLink = ({ path = '/', children, className = '', ...props }) => {
    const { i18n } = useTranslation();

    const lang = i18n.language?.startsWith('ru') ? 'ru' : 'en';

    const href = buildCrossDomainLink({
        baseUrl: process.env.REACT_APP_NEXT_URL,
        path,
        lang,
    });

    return (
        <a href={href} className={className} {...props}>
            {children}
        </a>
    );
};

export default CrossDomainLink;